export const projects = [
    {
        title: "Forum Login Service",
        subtitle: "FastAPI Stack",
        description:
            "",
        image: "./img/project-1.gif",
        link: "https://github.com/peppehermes/forum-login-service",
    },
    {
        title: "E-Commerce Payment Service",
        subtitle: "Spring Boot API",
        description:
            "",
        image: "./img/project-4.gif",
        link: "https://github.com/peppehermes/cleafy-ecommerce",
    },
    {
        title: "SubitoBot",
        subtitle: "Python bot",
        description:
            "",
        image: "./img/project-2.gif",
        link: "https://github.com/peppehermes/subito_bot",
    },
    {
        title: "SplinterCell",
        subtitle: "Second-hand market",
        description:
            "",
        image: "./img/project-3.gif",
        link: "https://bitbucket.org/breadsticksengineering/mad-lab2/src/master/",
    },
];

export const skills = [
    "Python",
    "Java",
    "Kotlin",
    "Back-end",
    "React",
    "Postgres"
];

export const testimonials = [
    {
        name: "Carla Melia",
        company: "ORBYTA Tech",
        image: "./img/carla.jpg",
        quote: "Giuseppe conducted his master's thesis under my supervision, demonstrating remarkable dedication and a proactive approach to advancing the Lis2Speech project. Subsequently, he joined ORBYTA Tech, where he contributed to various projects and client engagements, quickly gaining experience and autonomy. His contributions were invaluable, and it was a pleasure to work with him."
    },
    {
        name: "Fabio Angelini",
        company: "MDOTM",
        image: "./img/fabio.jpg",
        quote: "At MDOTM, a fintech startup where every contribution is crucial, Giuseppe significantly aided in managing and developing our Python and Java codebase. His strengths include flexibility and reliability, consistently striving to support the team. He possesses great potential, and I regret that he could not remain with us longer."
    },
    {
        name: "Gianpaolo Pirastu",
        company: "Intesa Sanpaolo",
        image: "./img/gianpaolo.jpg",
        quote: "During his tenure in Intesa Sanpaolo, Giuseppe demonstrated remarkable improvement in numerous areas. He achieved greater autonomy, progressively assumed more responsibilities, and approached each project with precision and methodical diligence. His technical and communication skills have advanced significantly, making him an excellent asset to our team."
    },
];
